export default {
  selection: "प्रणाली भाषा चयन",
  english: "English",
  simplified_chinese: "中文（简体）",
  list: {
    en: "अंग्रेजी",
    zh: "चिनियाँ (चीन)",
    tw: "चिनियाँ (ताइवान)",
    vi: "भियतनामी",
    th: "थाई",
    id: "इन्डोनेसियाली",
    malay: "मलाय",
    jp: "जापानी",
    kr: "कोरियाली",
    my: "म्यान्मार",
    ar: "अर्जेन्टिनी",
    ru: "रसियाली",
    ne: "नेपाली",
    bn: "बंगला"
  }
};
